import { ApolloError } from '@apollo/client'
import { Alert, Typography } from '@mui/material'
import { ZodError } from 'zod'
import { isMarketingApiError, MarketingApiError } from '~/lib/types/error/MarketingApiError'

type Props = {
  title: string
  error: MarketingApiError | ApolloError
}

export const ErrorAlert: React.FC<Props> = ({ title, error }) => {
  return isMarketingApiError(error) ? (
    <MarketingErrorAlert title={title} error={error} />
  ) : (
    <ApolloErrorAlert title={title} error={error} />
  )
}

const MarketingErrorAlert = ({ title, error }: { title: string; error: MarketingApiError }) => (
  <Alert severity="error">
    <Typography>{title}</Typography>
    <ul>
      {error.response.data.error.messages.map((message, i) => (
        <li key={i}>
          <Typography>{message}</Typography>
        </li>
      ))}
    </ul>
    <Typography>エラーコード： {error.response.data.error.code}</Typography>
  </Alert>
)

const ApolloErrorAlert = ({ title, error }: { title: string; error: ApolloError }) => (
  <Alert severity="error">
    <Typography>{title}</Typography>
    <Typography>{error.message}</Typography>
    {error.graphQLErrors.some((e) => e.extensions?.inquiryCode) && (
      <Typography>
        お問い合わせコード：
        {error.graphQLErrors.flatMap((e) => e.extensions?.inquiryCode && [e.extensions.inquiryCode]).join(', ')}
      </Typography>
    )}
  </Alert>
)

export const ZodErrorAlert = ({ title, error }: { title: string; error: ZodError }) => {
  return (
    <Alert severity="error">
      <Typography>{title}</Typography>
      <ul>
        {error.errors.map((issue, i) => (
          <li key={i}>
            <Typography variant="body2">
              {issue.path.length > 0 ? `${issue.path.join('.')}: ` : ''}
              {issue.message}
            </Typography>
          </li>
        ))}
      </ul>
    </Alert>
  )
}
